import { BundleCharity } from "@/api/Charities"
import LogoImage from "@/components/images/LogoImage"
import { twMerge } from "tailwind-merge"

export interface NewsReelArticleLogosProps {
  items: BundleCharity[]
  className?: string
}

const NewsReelArticleLogos: React.FC<NewsReelArticleLogosProps> = ({ items = [], className }) => {
  return (
    <div className={twMerge(`grid grid-cols-5 gap-2 lg:w-full mt-2 `, className)}>
      {items.map((item) => (
        <div
          key={item.id}
          className="flex h-12 bg-white rounded-lg border border-[#D7D7D7] items-center justify-center flex-1 p-1">
          <LogoImage src={item.logo} alt={item.name} width={42} height={42} className="max-h-full max-w-full" />
        </div>
      ))}
    </div>
  )
}
export default NewsReelArticleLogos
